import React, { Component, useMemo } from 'react';
import JoditEditor from "jodit-react";
import {backend_url} from "../../Helpers/Rest"
import PropTypes from 'prop-types';

var oldText = ""
export default class HtmlEditor extends Component {
    state = {}

    config = () => {

        try{
            var user_data = JSON.parse(localStorage.getItem("user_data"))
            if(!user_data){
                user_data = {}
            }
        }catch(e){ 
            var user_data = {}
        }

        return {  
            enableDragAndDropFileToEditor: false,
            removeButtons: ['file'],
            uploader: {
                "url": "",
                "insertImageAsBase64URI": true,
                "imagesExtensions": [
                    "jpg",
                    "png",
                    "jpeg",
                    "gif"
                ],
                headers: {
                    Authorization: user_data.token
                },  
                isSuccess: function (resp) {
                    console.log(resp)
                    return !resp.error;
                },
                getMessage: function (resp) {
                    console.log(resp)
                    return resp.msg;
                },
                process: function (resp) {
                    console.log(resp)
                        return {
                        };
                }, 
                error: function (e) {
                    console.log(e)
                }
            },
            askBeforePasteFromWord: false,
            askBeforePasteHTML: false
        } 
 
    }

    componentDidMount = () => {
      oldText = this.props.value
    };

    shouldComponentUpdate = () => {
        return false
    }
    

    setNewContent = (text)=>{

        //console.log(oldText)
        //console.log(text)

        //if(oldText!=text){
            this.props.onChange({
                target:{
                    name: this.props.name,
                    value: text
                }
            })
        //} 
        //oldText = text
    }

    joditRef = jodit => this.jodit = jodit;
    
  render() {
      console.log(this.state)
    return (
      <div className="mt-2 mb-3">
            <JoditEditor
                ref={this.joditRef}
                editorRef={this.joditRef}  
                value={this.props.value && this.props.value!='undefined'? this.props.value : ""}
                config={this.config()}
                tabIndex={1} // tabIndex of textarea 
                onBlur={newContent => this.setNewContent(newContent)} // preferred to use only this option to update the content for performance reasons
                //onChange={(newContent) => {this.setState({[this.props.name]:newContent})}}
            />
      </div>
    );
  }
}

HtmlEditor.propTypes = {
    name: PropTypes.string, 
    value: PropTypes.string,
    onChange: PropTypes.func, 
}